<template>
  <div>
    <div id="access-source" style="height: 400px; width: 488px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xAxis: [],
    };
  },
  props: ["newUsers"],
  watch: {
    newUsers: function (newVal, oldVal) {
      for (let i = 0; i < 7; i++) {
        this.xAxis.unshift(this.$global.getDay(-i));
      }
      // console.log(this.xAxis);
      this.createChart();
      // console.log(this.newUsers);
    },
  },
  methods: {
    createChart() {
      let that = this;
      var chartDom = document.getElementById("access-source");
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          borderColor: "transparent",
          borderWidth: "5",
          formatter: function (params) {
            return params[0].name + ": " + params[0].value;
          },
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        xAxis: {
          data: that.xAxis,
          axisTick: { show: false },
          axisLine: { show: true },
          axisLabel: {
            color: "#5470C6",
            interval: 0,
            rotate: 45,
          },
        },
        yAxis: {
          offset: 26,
          itemStyle: {
            left: -10,
          },
          splitLine: { show: true },
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: true },
        },
        color: ["#5470C6"],
        series: [
          {
            label: {
              show: true,
              formatter: [
                "{c} ", //引导线上面文字
              ].join("\n"), //用\n来换行
              color: "#434343",
              position: "outside",
            },
            name: "hill",
            type: "pictorialBar",
            barCategoryGap: "-130%",
            // symbol: 'path://M0,10 L10,10 L5,0 L0,10 z',
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              opacity: 0.5,
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
              },
            },
            data: that.newUsers,
            z: 20,
          },
        ],
      };
      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
#access-source {
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/NewUsers.vue